"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaService = void 0;
const api_1 = require("../api");
class SchemaService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    compileSchema(body) {
        return this.fetch(`/${this.apiVersion}/schema/compile`, {
            method: "POST",
            body: body,
        });
    }
}
exports.SchemaService = SchemaService;
exports.default = SchemaService;
